import React, { Dispatch, FC, SetStateAction } from "react";
import { Modal } from "./Modal";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { useFormik } from "formik";
import * as yup from "yup";

export type BranchDeleteProps = {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  branch: any;
  onDelete: (branch: any) => void;
};

export const BranchDeleteForm: FC<BranchDeleteProps> = ({
  visible,
  setVisible,
  onDelete,
  branch,
}) => {
  const formik = useFormik({
    initialValues: {
      branch: "",
    },
    validationSchema: yup.object({
      branch: yup.string().required("El campo es requerido"),
    }),
    onSubmit() {
      onDelete(branch);
    },
  });

  return (
    <Modal
      Close={() => {
        setVisible(false);
        formik.resetForm();
      }}
      open={visible}
      onClickCreate={formik.handleSubmit}
      onClose={() => {
        setVisible(false);
        formik.resetForm();
      }}
      tittleModal="Borrar filial"
      textButtonCreate="Borrar"
      textButtonClose="Cancelar"
      disabledCreated={formik.isSubmitting || formik.values.branch !== "delete"}
      loader={formik.isSubmitting}
    >
      <div className="w-full">
        <p>
          Para confirmar la eliminación escriba "delete" en el campo de abajo
        </p>
        <div className="w-full mt-3">
          <InputWithCornerHint
            label=""
            name="branch"
            type="text"
            placeholder="Escriba delete"
            onChange={formik.handleChange}
            error={formik.errors.branch}
            textError={formik.errors.branch}
            value={formik.values.branch}
          />
        </div>
      </div>
    </Modal>
  );
};
